import script from "./AbitFormBuilder.vue?vue&type=script&setup=true&lang=ts"
export * from "./AbitFormBuilder.vue?vue&type=script&setup=true&lang=ts"

import "./AbitFormBuilder.vue?vue&type=style&index=0&id=74c7b006&scoped=true&lang=css"

import exportComponent from "/var/www/abit/resources/js/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74c7b006"]])

export default __exports__